/**
 * RS money formatting — presentment currency via Intl (Shopify Markets).
 */
(function () {
  function resolveCurrencyCode(overrides = {}) {
    return overrides.currencyCode ?? window.Shopify?.currency?.active ?? window.themeVariables?.settings?.currencyCode ?? null;
  }

  function resolveLocale(overrides = {}) {
    return overrides.locale ?? window.Shopify?.locale ?? window.themeVariables?.settings?.locale ?? document.documentElement.lang ?? "en";
  }

  function resolveCurrencyCodeEnabled(overrides = {}) {
    return (
      overrides.currencyCodeEnabled ??
      window.themeVariables?.settings?.currencyCodeEnabled ??
      false
    );
  }

  window.RsMoney = {
    format(cents, overrides = {}) {
      const currencyCode = resolveCurrencyCode(overrides);
      if (!currencyCode) {
        return String(cents);
      }

      const locale = resolveLocale(overrides);
      const currencyCodeEnabled = resolveCurrencyCodeEnabled(overrides);

      try {
        const formatted = new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currencyCode,
        }).format(Number(cents) / 100);

        if (currencyCodeEnabled && !formatted.includes(currencyCode)) {
          return `${formatted} ${currencyCode}`;
        }

        return formatted;
      } catch (error) {
        return String(cents);
      }
    },
  };
})();
